
import FarmInfo from "@/components/Sidebar/FarmInfo.vue";
import AddFarmButton from "@/components/AddFarmButton.vue";
import UpdateFarmModal from "@/components/Modals/UpdateFarmModal.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { gettersInstance } from "@/lib/util";
import { Farm } from "@/lib/types/Farm";
import { RawLocation } from "vue-router";

const StoreGetters = gettersInstance(["sharedFarms", "userFarms", "farmsWithSeasons", "currentFarmId", "user"]);

@Component({
  name: "FarmPickerMenu",
  components: { UpdateFarmModal, AddFarmButton, FarmInfo },
})
export default class FarmPickerMenu extends mixins(MixedVue, StoreGetters) {
  static components: {
    UpdateFarmModal: typeof UpdateFarmModal;
    AddFarmButton: typeof AddFarmButton;
    FarmInfo: typeof FarmInfo;
  };

  showAddFarmModal: boolean = false;

  get activeSharedFarms(): Farm[] {
    return this.sharedFarms.filter((f) => !f.licenseExpired);
  }

  get expiredSharedFarms(): Farm[] {
    return this.sharedFarms.filter((f) => f.licenseExpired);
  }

  openAddFarmModal() {
    this.showAddFarmModal = true;
  }

  routeToHome(farm: Farm): RawLocation {
    // TODO: Add error message, we have no idea what to do with this farm.
    if (!farm.hasSeasons && !farm.hasFullAcess) return "";

    // If the farm has no seasons push the user to the manage farm page
    if ((!farm.hasSeasons || farm.parcel_count == 0) && farm.hasFullAcess) {
      return {
        name: "manage-farm",
        params: {
          farmId: farm.id,
        },
      };
    }

    // The user only has access to some parcels, move to the
    // map view of the first one.
    if (farm.parcelAccessOnly && farm.sharedParcels.length > 0) {
      const parcel = farm.sharedParcels[0];
      return {
        name: "map-shared-parcel",
        params: {
          farmId: farm.id,
          seasonId: parcel.season,
          parcelId: parcel.id,
        },
        query: { rasterKind: this.rasterKind },
      };
    }

    // The user has "view_only" or above access
    if (farm.hasAccess || farm.hasFullAcess) {
      return {
        name: "map",
        params: { farmId: farm.id, date: null },
        query: { rasterKind: this.rasterKind },
      };
    }
    // TODO: Add error message, we have no idea what to do with this farm.
    return "";
  }
}
